module.exports = __webpack_public_path__ + "static/media/icon.e37da8f5.png";